<template>
    <a v-if="employeelink == 1" :href="'/employees/' + employee.id" class="text-underline-hover">{{ employee.lastname
    }}, {{ employee.forename }}</a>
    <span v-if="employeelink != 1">{{ employee.lastname }}, {{ employee.forename }}</span>
    &nbsp;
    <div v-if="employee.externalstamps && employee.externalstamps.length > 0 && can('external-stamps-list')"
        @click.stop="$emit('toggle-external', employee.id)">
        <span class="material-symbols-outlined text-black ms-1" v-tooltip
            :title="$trans.get('__JSON__.This employee has external stamps')">
            tooltip_2
        </span>
    </div>
    <span v-if="employee.employer && employee.employer.shortname != 'HAL'" class="material-symbols-outlined float-end"
        v-tooltip :title="employee.employer.name"> work_history
    </span>
    &nbsp;<employee-info :employee_id="employee.id" />
</template>

<script>
export default {
    setup() {
    },
    name: "Employee",
    emits: ['toggle-external'],
    created() {
    },
    props: {
        employeelink: String,
        employee: Object
    },
    data() {
        return {
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {

    }
};
</script>

<style scoped></style>
